import { render } from "./TrayArrowUp.vue?vue&type=template&id=ae55bf4e"
import script from "./TrayArrowUp.vue?vue&type=script&lang=js"
export * from "./TrayArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__